import React from 'react'
import InfoContent from 'components/InfoContent'
import finish1 from './img/finish1.png'
import finish2 from './img/finish2.png'

export default function RideGuide(props) {
    const contents = [
        {
            title: "اسکوتر را قفل کنید",
            description: "پس از استفاده از اسکوتر  آن را پارک کنید و در برنامه گزینه پایان سفر را انتخاب کنید تا اسکوتر قفل شود. به هیچ وجه اسکوتر را قبل از اینکه قفل شود رها نکنید",
            img: finish1
        },
        {
            title: "مکان مناسب پارک",
            description: "همیشه پس از پایان سفر اسکوتر را در یک فضای عمومی پارک کنید. دقت کنید اسکوتر در خیابان یا مسیر رفت و آمد دیگران نباشد یا برای شهروندان مزاحمتی ایجاد نکند ",
            img: finish2
        },
    ]

    return <InfoContent contents={contents} autoplay={false} />
}